module.exports = __webpack_public_path__ + "static/media/icons_administracion.f0b38a93.png";